import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Lenis smooth-scroll wrapper for cinematic page motion.
 *
 * Why this exists (Feb 2026): the TripDetail redesign removed tabs and
 * placed all content inline along a single scroll axis. Default browser
 * scroll feels mechanical for the long-form layout; Lenis interpolates
 * the scroll position so cards reveal smoothly under the IntersectionObserver
 * trigger in FadeInDirection, matching the motion language of /go and
 * /apresentacao. Used as a per-page wrapper (not global) because some
 * routes (admin, forms) need native scroll for accessibility/perf.
 *
 * The hook also exposes `lenis.scrollTo(target)` via a module-level
 * singleton so FloatingNavbar anchor clicks animate instead of jumping.
 */
let lenisInstance = null;

export function getLenis() {
  return lenisInstance;
}

export function LenisProvider({ children }) {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      // Native scroll on touch — Lenis on touch fights with iOS rubber-banding.
      smoothTouch: false,
      touchMultiplier: 2,
    });
    lenisInstance = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  return children;
}
